import { z } from "zod";

/** Dias em que a organização fica congelada antes de ser excluída — dá pra desfazer até lá. */
export const DIAS_ATE_A_EXCLUSAO = 7;
const DIA = 24 * 60 * 60 * 1000;

export const previsaoDaExclusao = (agora: Date) => new Date(agora.getTime() + DIAS_ATE_A_EXCLUSAO * DIA);

/** Dias inteiros que faltam (arredonda pra cima: faltando 2h ainda é "1 dia"); nunca negativo. */
export const diasParaExclusao = (prevista: Date, agora: Date) => Math.max(0, Math.ceil((prevista.getTime() - agora.getTime()) / DIA));

/**
 * O que ainda se escreve numa organização congelada: desfazer e exportar, trocar ou criar outra
 * organização, a própria conta (perfil, privacidade, PIN, favoritos), ler notificações, sair do
 * "ver como" e recusar convites. Todo o resto vira só leitura.
 */
const LIBERADOS = [
  "organization.exclusao.desfazer",
  "organization.exportacao.",
  "organization.switch",
  "organization.create",
  "me.",
  "privacidade.",
  "pin.",
  "favorito.",
  "notification.",
  "verComo.",
  "auth.",
];

export function podeMutarCongelada(path: string) {
  return path.endsWith(".declineMine") || LIBERADOS.some((p) => (p.endsWith(".") ? path.startsWith(p) : path === p));
}

/** Confirmação de excluir: o nome digitado e a identidade (senha, ou o e-mail em conta sem senha). */
export const agendarExclusaoSchema = z.object({
  nomeDaOrganizacao: z.string().trim().min(1).max(200),
  senha: z.string().max(200).optional(),
  emailDeConfirmacao: z.string().trim().max(320).optional(),
});
export type AgendarExclusaoInput = z.infer<typeof agendarExclusaoSchema>;

/** Nome digitado confere com o da organização (sem diferença de maiúsculas, acentos e espaços nas pontas). */
export const confereNomeDaOrganizacao = (digitado: string, nome: string) =>
  digitado.trim().localeCompare(nome.trim(), "pt-BR", { sensitivity: "base" }) === 0;
